import payment_and_purchase from "./payment_and_purchase.png";
import receive from "./receive.png";
import reports from "./reports.png";
import calender from "./calender.png";
import support from "./support.png";
import contact_us from "./contact_us.png";
import functions from "./functions.png";
import setting from "./setting.png";
import questionsAndSuggestions from "./questionsAndSuggestions.png";
import stepByStepBanner from "./stepByStepBanner.png";
import quickStartBanner from "./quickStartBanner.png";
import quickStartLastSectionImage from "./quickStartLastSectionImage.png";
import quickStartTopSectionImage from "./quickStartTopSectionImage.png";
import stepByStepLastSectionImage from "./stepByStepLastSectionImage.png";
import stepByStepTopSectionImage from "./stepByStepTopSectionImage.png";
import next from "./next.svg";
import stepThreeItemsIcon from "./stepThreeItemsIcon.png";
import stepThreeContentImage from "./stepThreeContentImage.png";
import bazaar from "./bazaar.png";
import googleplay from "./googleplay.png";
import appstore from "./appstore.png";
import _else from "./else.png";
import skyscrapers from "./skyscrapers.png";
import maintenance from "./maintenance.png";
import payroll from "./payroll.png";
import profileSetting from "./profileSetting.png";
import services from "./services.png";
import telegram from "./telegram.png";
import faq from "./faq.png";
import gif_hover from "./gif_hover.png";
import phone from "./phone.png";
import footerPhone from "./footerPhone.png";
import fax from "./fax.png";
import smartPhoneVideoTrigger from "./smartPhoneVideoTrigger.png";
import popupBackground from "./popupBackground.png";
import checkAccounts from "./checkAccounts.png";


export {
	faq,
	payment_and_purchase,
	receive,
	reports,
	calender,
	support,
	contact_us,
	setting,
	functions,
	questionsAndSuggestions,
	next,
	stepByStepBanner,
	quickStartBanner,
	quickStartLastSectionImage,
	stepByStepLastSectionImage,
	quickStartTopSectionImage,
	stepByStepTopSectionImage,
	stepThreeItemsIcon,
	stepThreeContentImage,
	bazaar,
	googleplay,
	appstore,
	_else,
	skyscrapers,
	maintenance,
	payroll,
	profileSetting,
	services,
	telegram,
	gif_hover,
	phone,
	footerPhone,
	fax,
	smartPhoneVideoTrigger,
	popupBackground,
	checkAccounts
}